var _path, _path2, _path3, _g, _g2, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnknownRecommendations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 89,
    viewBox: "0 0 135 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9272 18.6207C47.7087 14.435 43.8444 11.3742 39.2558 11.3742C38.6276 11.3742 38.0156 11.4399 37.4197 11.5493C37.5879 10.8596 37.6868 10.1445 37.6868 9.40549C37.6868 4.21109 33.2721 0 27.8254 0C22.704 0 18.4961 3.72524 18.0124 8.4906C12.8742 9.32679 9 13.0411 9 17.4992C9 17.5259 9.00491 17.5519 9.00491 17.5786H11.5716C13.611 17.5786 15.2964 19.0737 15.5453 21H47.0609C48.332 21 49.2749 19.8141 48.9272 18.6207Z",
    fill: "#EEF0F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.228 21.2077C126.727 21.2077 126.239 21.2608 125.763 21.3495C125.897 20.7911 125.976 20.2122 125.976 19.614C125.976 15.409 122.455 12 118.111 12C114.026 12 110.67 15.0157 110.284 18.8733C106.185 19.5503 103.095 22.5571 103.095 26.166C103.095 26.1876 103.099 26.2087 103.099 26.2303C103.099 26.2303 102.901 27.4406 103.099 29H133.453C134.467 29 135.219 28.04 134.942 27.0739C133.97 23.6855 130.888 21.2077 127.228 21.2077Z",
    fill: "#EEF0F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3967 20H2.6026C1.1676 20 0 21.1676 0 22.6033V24.3967C0 25.8324 1.1676 27 2.6026 27H11.3967C12.8324 27 14 25.8324 14 24.3967V22.6033C14 21.1676 12.8324 20 11.3967 20Z",
    fill: "#EEF0F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.5469 66.2719H45.4531C43.0587 66.2719 41 64.1676 41 61.7054V31.5665C41 29.1042 43.0587 27 45.4531 27H93.5469C95.9413 27 98 29.1042 98 31.5665V61.7054C98 64.1676 95.9413 66.2719 93.5469 66.2719Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4531 28C43.6335 28 42 29.6337 42 31.5665V61.7054C42 63.6382 43.6335 65.2719 45.4531 65.2719H93.5469C95.3665 65.2719 97 63.6382 97 61.7054V31.5665C97 29.6337 95.3665 28 93.5469 28H45.4531ZM40 31.5665C40 28.5748 42.4838 26 45.4531 26H93.5469C96.5162 26 99 28.5748 99 31.5665V61.7054C99 64.697 96.5162 67.2719 93.5469 67.2719H45.4531C42.4838 67.2719 40 64.697 40 61.7054V31.5665Z",
    fill: "#B8C1CA"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 33C45 31.8954 45.8954 31 47 31H91.8571C92.9617 31 93.8571 31.8954 93.8571 33V60.0041C93.8571 61.1087 92.9617 62.0041 91.8571 62.0041H47C45.8954 62.0041 45 61.1087 45 60.0041V33Z",
    fill: "#EEF0F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.128 87.1513C115.262 88.2829 117.057 88.2829 118.191 87.1513C119.277 86.0197 119.277 84.2281 118.144 83.0493L110.49 75.4112C112.852 72.2522 114.222 68.3388 114.222 64.0954C114.222 53.534 105.623 45 95.0874 45C84.5516 45 76 53.534 76 64.0954C76 74.6568 84.5516 83.1908 95.1347 83.1908C99.3868 83.1908 103.308 81.8235 106.474 79.466L114.128 87.1513ZM81.6695 64.1425C81.6695 56.7401 87.6698 50.7522 95.0874 50.7522C102.505 50.7522 108.505 56.7401 108.505 64.1425C108.505 71.545 102.505 77.5329 95.0874 77.5329C87.6698 77.5329 81.6695 71.545 81.6695 64.1425Z",
    fill: "#B8C1CA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.0874 46C85.1035 46 77 54.0866 77 64.0954C77 74.1026 85.1019 82.1908 95.1347 82.1908C99.1688 82.1908 102.881 80.8946 105.876 78.664L106.571 78.1466L114.834 86.4435C114.834 86.4439 114.835 86.4443 114.835 86.4447C115.576 87.183 116.733 87.1851 117.477 86.451C118.173 85.7183 118.192 84.5483 117.429 83.7493L109.17 75.5066L109.689 74.8123C111.924 71.8237 113.222 68.1198 113.222 64.0954C113.222 54.0898 105.075 46 95.0874 46ZM75 64.0954C75 52.9814 83.9996 44 95.0874 44C106.172 44 115.222 52.9782 115.222 64.0954C115.222 68.2466 113.974 72.104 111.796 75.3021L118.857 82.3487L118.864 82.3561C120.361 83.9116 120.38 86.3151 118.912 87.844L118.905 87.8516L118.897 87.8591C117.373 89.3803 114.946 89.3803 113.421 87.8591L113.419 87.857L106.363 80.7717C103.158 82.9457 99.2936 84.1908 95.1347 84.1908C84.0012 84.1908 75 75.211 75 64.0954ZM80.6695 64.1425C80.6695 56.1859 87.1195 49.7522 95.0874 49.7522C103.055 49.7522 109.505 56.1859 109.505 64.1425C109.505 72.0992 103.055 78.5329 95.0874 78.5329C87.1195 78.5329 80.6695 72.0992 80.6695 64.1425ZM95.0874 51.7522C88.2201 51.7522 82.6695 57.2944 82.6695 64.1425C82.6695 70.9907 88.2201 76.5329 95.0874 76.5329C101.955 76.5329 107.505 70.9907 107.505 64.1425C107.505 57.2944 101.955 51.7522 95.0874 51.7522Z",
    fill: "#FAFAFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94 76C100.627 76 106 70.4036 106 63.5C106 56.5964 100.627 51 94 51C87.3726 51 82 56.5964 82 63.5C82 70.4036 87.3726 76 94 76Z",
    fill: "#FAFAFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2919 51H67.1627C67.1627 49.9783 67.3349 49.0868 67.6794 48.3253C68.0239 47.5639 68.7225 46.788 69.7751 45.9976C70.3684 45.5542 70.7608 45.2072 70.9522 44.9566C71.1435 44.706 71.2392 43.359 71.2392 42.9157C71.2392 42.3181 71.0335 41.841 70.622 41.4843C70.2105 41.1277 69.6507 40.9494 68.9426 40.9494C67.622 40.9494 66.7416 41.6434 66.3014 43.0313L63 42.1639C63.9187 39.3879 65.9282 38 69.0287 38C70.5981 38 71.9856 38.3952 73.1914 39.1855C74.3971 39.9759 75 41.1036 75 42.5687C75 44.0916 74.3397 46.3349 73.0191 47.2988C71.9474 48.0699 71.2249 48.7012 70.8517 49.1928C70.4785 49.6843 70.2919 50.2867 70.2919 51ZM66.7513 56.2602V52.7602H70.2919V56.2602H66.7513Z",
    fill: "#B8C1CA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 38,
    y: 26,
    width: 63,
    height: 45.2719,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592157 0 0 0 0 0.592157 0 0 0 0 0.592157 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 37,
    y: 25,
    width: 65,
    height: 47.2719,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592157 0 0 0 0 0.592157 0 0 0 0 0.592157 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownRecommendations);
export default __webpack_public_path__ + "static/media/unknownRecommendations.a938d59c66e5a87ccd587af696856226.svg";
export { ForwardRef as ReactComponent };